/**
 * STANLEY 1913 - Gift Option Feature
 * ----------------------------------------------------------------------------
 * Maneja el checkbox "Agregar bolsa de regalo 🎁" presente en cada línea de
 * producto del carrito (drawer y página /cart).
 *
 * Reglas:
 *  - Marcar checkbox  -> POST /cart/add.js (1 unidad de la bolsa, con la
 *                        propiedad _gift_for: <line_item_key>).
 *  - Desmarcar        -> POST /cart/change.js con quantity:0 sobre la línea
 *                        de la bolsa correspondiente.
 *  - Si el usuario elimina manualmente la bolsa  -> limpia el flag.
 *  - Si el usuario elimina un producto con regalo activo -> elimina la bolsa
 *    huérfana asociada y limpia el flag.
 *  - Persiste el estado en localStorage con prefijo `giftOption_<line_key>`.
 *
 * El feature reusa el sistema de `cart:update` del tema: dispatchea el evento
 * con sections para que `cart-items-component` aplique morphSection sin
 * recargar.
 * ----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // -------- Config ----------------------------------------------------------
  var CFG = window.STANLEY_GIFT_BAG || {};
  var GIFT_VARIANT_ID = CFG.variantId || null;
  var GIFT_SKU = CFG.sku || '10-00024-001';
  var LS_PREFIX = CFG.lsPrefix || 'giftOption_';
  var GIFT_PROPERTY = CFG.property || '_gift_for';

  if (!GIFT_VARIANT_ID) {
    console.warn(
      '[GiftOption] window.STANLEY_GIFT_BAG.variantId no disponible. ' +
        'Verificá que el producto con handle "producto-de-regalo" exista.'
    );
  }

  // -------- localStorage helpers --------------------------------------------
  function readFlags() {
    var out = {};
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf(LS_PREFIX) === 0) {
          var lineKey = k.substring(LS_PREFIX.length);
          out[lineKey] = localStorage.getItem(k) === 'true';
        }
      }
    } catch (e) {
      /* localStorage puede fallar en modo privado */
    }
    return out;
  }

  function setFlag(lineKey, value) {
    try {
      if (value) {
        localStorage.setItem(LS_PREFIX + lineKey, 'true');
      } else {
        localStorage.removeItem(LS_PREFIX + lineKey);
      }
    } catch (e) {
      /* noop */
    }
  }

  // -------- Cart helpers ----------------------------------------------------
  function getCartSectionIds() {
    var ids = [];
    var nodes = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < nodes.length; i++) {
      var sid = nodes[i].dataset.sectionId;
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    }
    return ids;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function addGiftBag(forLineKey) {
    if (!GIFT_VARIANT_ID) return Promise.reject(new Error('Gift variant id missing'));
    var props = {};
    props[GIFT_PROPERTY] = forLineKey;
    var body = {
      items: [
        {
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: props,
        },
      ],
      sections: getCartSectionIds().join(','),
      sections_url: window.location.pathname,
    };
    return postJSON('/cart/add.js', body);
  }

  function removeLine(lineKey) {
    var body = {
      id: lineKey,
      quantity: 0,
      sections: getCartSectionIds().join(','),
      sections_url: window.location.pathname,
    };
    return postJSON('/cart/change.js', body);
  }

  // -------- Cart inspection -------------------------------------------------
  function isGiftBagItem(item) {
    return item && item.sku === GIFT_SKU;
  }

  function findGiftLineFor(cart, productLineKey) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!isGiftBagItem(it)) continue;
      var props = it.properties || {};
      if (props[GIFT_PROPERTY] === productLineKey) return it;
    }
    return null;
  }

  function getActiveProductLineKeys(cart) {
    var set = {};
    if (!cart || !cart.items) return set;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!isGiftBagItem(it)) set[it.key] = true;
    }
    return set;
  }

  function getGiftForValuesInCart(cart) {
    var set = {};
    if (!cart || !cart.items) return set;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftBagItem(it)) {
        var v = (it.properties || {})[GIFT_PROPERTY];
        if (v) set[v] = true;
      }
    }
    return set;
  }

  // -------- Event dispatch (reusa sistema del tema) -------------------------
  function dispatchCartUpdate(sections) {
    var detail = {
      resource: {},
      sourceId: 'gift-option',
      data: {
        source: 'gift-option',
        sections: sections || {},
      },
    };
    document.dispatchEvent(
      new CustomEvent('cart:update', { bubbles: true, detail: detail })
    );
  }

  // -------- UI sync ---------------------------------------------------------
  /**
   * Reordena visualmente las filas: cada fila marcada con [data-gift-for]
   * se mueve para que quede inmediatamente debajo de la fila del producto
   * que la generó (matched por data-line-key === data-gift-for).
   *
   * Solo afecta el DOM del cart visible — no toca el cart real ni el orden
   * que ve el checkout de Shopify.
   */
  function reorderRows() {
    var giftRows = document.querySelectorAll('[data-gift-for]');
    for (var i = 0; i < giftRows.length; i++) {
      var giftRow = giftRows[i];
      var forKey = giftRow.getAttribute('data-gift-for');
      if (!forKey) continue;

      var tbody = giftRow.parentNode;
      if (!tbody) continue;

      // Buscar el row del producto target en el mismo tbody (excluir gift rows)
      var productRow = null;
      var rows = tbody.children;
      for (var j = 0; j < rows.length; j++) {
        if (
          rows[j].getAttribute('data-line-key') === forKey &&
          !rows[j].hasAttribute('data-gift-for')
        ) {
          productRow = rows[j];
          break;
        }
      }
      if (!productRow) continue;

      // Mover solo si no está ya en la posición correcta
      if (productRow.nextSibling !== giftRow) {
        tbody.insertBefore(giftRow, productRow.nextSibling);
      }
    }
  }

  function updateCheckboxesUI() {
    var flags = readFlags();
    var nodes = document.querySelectorAll('[data-gift-checkbox]');
    for (var i = 0; i < nodes.length; i++) {
      var cb = nodes[i];
      var key = cb.getAttribute('data-line-key');
      if (!key) continue;
      cb.checked = !!flags[key];
    }
    reorderRows();
  }

  /**
   * Sincroniza estado de localStorage con el cart real.
   * - Limpia flags huérfanos (productos eliminados).
   * - Detecta bolsas eliminadas manualmente y limpia flags.
   * - Elimina bolsas huérfanas (cuyo producto fue eliminado).
   * - Refresca estado visual de checkboxes.
   */
  var isSyncing = false;
  function syncState() {
    if (isSyncing) return Promise.resolve();
    isSyncing = true;

    return fetchCart()
      .then(function (cart) {
        var flags = readFlags();
        var activeProductKeys = getActiveProductLineKeys(cart);
        var giftForInCart = getGiftForValuesInCart(cart);

        var orphanGiftKeys = [];

        for (var lineKey in flags) {
          if (!flags[lineKey]) continue;
          if (!activeProductKeys[lineKey]) {
            // Producto fue eliminado -> limpiar flag
            setFlag(lineKey, false);
            // Si dejó una bolsa huérfana, marcarla para borrar
            var giftLine = findGiftLineFor(cart, lineKey);
            if (giftLine) orphanGiftKeys.push(giftLine.key);
          } else if (!giftForInCart[lineKey]) {
            // Producto sigue, pero la bolsa fue eliminada manualmente
            setFlag(lineKey, false);
          }
        }

        // Eliminar bolsas huérfanas en cadena
        var chain = Promise.resolve(null);
        orphanGiftKeys.forEach(function (giftKey) {
          chain = chain.then(function () {
            return removeLine(giftKey);
          });
        });

        return chain.then(function (lastResp) {
          updateCheckboxesUI();
          if (orphanGiftKeys.length && lastResp && lastResp.sections) {
            dispatchCartUpdate(lastResp.sections);
          }
        });
      })
      .catch(function (err) {
        console.warn('[GiftOption] syncState error:', err);
      })
      .then(function () {
        isSyncing = false;
      });
  }

  // -------- Checkbox handler ------------------------------------------------
  function handleCheckboxChange(cb) {
    var lineKey = cb.getAttribute('data-line-key');
    if (!lineKey) return;

    cb.disabled = true;

    if (cb.checked) {
      addGiftBag(lineKey)
        .then(function (resp) {
          if (resp && resp.status && resp.status >= 400) {
            cb.checked = false;
            console.warn('[GiftOption] add error:', resp);
            return;
          }
          setFlag(lineKey, true);
          dispatchCartUpdate(resp && resp.sections);
        })
        .catch(function (err) {
          cb.checked = false;
          console.warn('[GiftOption] add error:', err);
        })
        .then(function () {
          cb.disabled = false;
        });
    } else {
      fetchCart()
        .then(function (cart) {
          var giftLine = findGiftLineFor(cart, lineKey);
          if (!giftLine) {
            // No hay bolsa que borrar (puede haber sido borrada antes). Limpio flag.
            setFlag(lineKey, false);
            return null;
          }
          return removeLine(giftLine.key).then(function (resp) {
            setFlag(lineKey, false);
            dispatchCartUpdate(resp && resp.sections);
            return resp;
          });
        })
        .catch(function (err) {
          cb.checked = true; // rollback visual
          console.warn('[GiftOption] remove error:', err);
        })
        .then(function () {
          cb.disabled = false;
        });
    }
  }

  // -------- Event delegation ------------------------------------------------
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-gift-checkbox]')) {
      handleCheckboxChange(t);
    }
  });

  // Re-sync después de cualquier update del cart (incluye los disparados por
  // el propio tema: agregar producto, cambiar quantity, eliminar línea, etc).
  // Debounce para evitar múltiples syncs en cascada.
  var syncTimer = null;
  document.addEventListener('cart:update', function () {
    // Reorder inmediato (después del morph) para minimizar flicker visual
    setTimeout(reorderRows, 0);
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(syncState, 100);
  });

  // -------- Initial sync ----------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reorderRows(); // instantáneo: el DOM ya tiene los data-gift-for
      syncState();
    });
  } else {
    reorderRows();
    syncState();
  }
})();